import React, { lazy } from "react";
import { authRoles } from "../../auth/authRoles";

const ModuleManagement = lazy(() => import("./ModuleManagment")
);

const moduleManagementRoutes = [
  {
    path: "/module-management",
    element: <ModuleManagement/>,
    auth: authRoles.admin,
  },
];

export default moduleManagementRoutes;